export default {
  placeholder: 'Wybierz dni powszednie',
};
